(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
(() => {
  const endsAt = Date.parse('2026-11-01T00:00:00+01:00');
  const styleId = 'candelae-duftvorteil-expired';

  let expiryTimer;

  function updateDuftvorteilVisibility() {
    clearTimeout(expiryTimer);
    const remaining = endsAt - Date.now();
    if (remaining > 0) {
      expiryTimer = setTimeout(updateDuftvorteilVisibility, Math.min(remaining, 2147483647));
      return;
    }
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '#mini-cart .candelae-duo-cart-nudge, #mini-cart .candelae-duo-cart-confirm { display: none !important; }';
    document.head.appendChild(style);
  }

  updateDuftvorteilVisibility();
  document.addEventListener('visibilitychange', updateDuftvorteilVisibility);
  window.addEventListener('pageshow', updateDuftvorteilVisibility);
})();

  } catch(e) { console.error(e); }
})();
})();
